import React, { useState, useEffect, useCallback } from "react";
import getConfig from "./config";
import { mapConfigToValidation } from "../../FormValidation";
import { checkValidation } from "../../FormValidation/utils";

export const initValidation = {
  firstName: true,
  lastName: true,
  emailAddress: true,
  phoneNumber: true,
  websiteAddress: true,
  memberNumber: true,
};
const listIdsForValidation = Object.keys(initValidation);

export const tosAndAttachmentValid = (attachments, tos, dispatch) => {
  let attachmentValid = true;
  let tosValid = true;
  const attachmentList = attachments || [];
  const hasNotUploadedResume = !attachmentList.find(
    ({ type }) => type === "resume",
  );

  if (hasNotUploadedResume) {
    dispatch({
      type: "onFileChange",
      error: "Please upload a resume",
    });
    attachmentValid = false;
  }
  if (!tos) {
    dispatch({
      type: "onChangeCheckbox",
      error: "Please accept terms",
      value: "terms",
    });
    tosValid = false;
  }
  return attachmentValid && tosValid;
};

const withFormValidation = (Component) => (props) => {
  const [valid, setValidState] = useState(initValidation);

  const setValid = useCallback((value) => {
    setValidState((prevValid) => ({ ...prevValid, ...value }));
  }, []);

  useEffect(() => {
    for (const id of listIdsForValidation) {
      checkValidation(
        {},
        props.formState,
        id,
        mapConfigToValidation(getConfig(props)),
        setValid,
      );
    }
  }, [props.formState, props, setValid]);

  return <Component {...props} valid={valid} setValid={setValid} />;
};

export default withFormValidation;
